export const StatusEnumForHidingFooter = ['IN_REVIEW', 'HIRED', 'REJECTED'];
export const StatusEnumForFooterVisible = ['NEW'];
